import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IBackgroundLightIconProps extends IconPropsType {}

const BackgroundLightIcon = ({ ...props }: IBackgroundLightIconProps) => (
  <svg
    width={375}
    height={356}
    viewBox="0 0 375 356"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3805_30750)">
      <g filter="url(#filter0_f_3805_30750)">
        <ellipse cx={191.5} cy={175} rx={77.5} ry={78} fill="#004719" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_3805_30750"
        x={-6}
        y={-23}
        width={395}
        height={396}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={60}
          result="effect1_foregroundBlur_3805_30750"
        />
      </filter>
      <clipPath id="clip0_3805_30750">
        <rect width={375} height={356} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BackgroundLightIcon;
